import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import {
  MainListItems,
  MovieGuideReportsListItems,
  ReportListItems,
  ImportToolsListItems,
} from "./ListItems";

export class SideBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: props.isOpen,
            onClick: props.onClick,
            importToolsOpen: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.setState({ open: this.props.isOpen });
        }
    }

    handleDrawerClose = (event) => {
        this.setState({ open: false });
        if (this.props.onClick != null) this.props.onClick(event.target.value); // callback
    };

    render() {
        const divStyle = {
            paddingBottom: "15px",
            zIndex: "0",
        };

        return (
            <div>
                <Drawer variant="persistent" open={this.state.open}>
                    <div style={divStyle}>
                        <IconButton onClick={this.handleDrawerClose}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </div>
                    <Divider />
                    <MainListItems />
                    <Divider />
                    <ImportToolsListItems />
                    <Divider />
                    <ReportListItems />
                    <Divider />
                    <MovieGuideReportsListItems />
                </Drawer>
            </div>
        );
    }
}